import {
  clearQueryCacheOnUserChange,
  createQueryClient,
} from '@zealth/core/query'

import { Sentry } from './sentry'

// The payload is one read per session and never refetches on its own: the
// table is written once a night, so a refetch could only return the same rows.
export const queryClient = createQueryClient({
  captureException: Sentry.captureException,
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})

// A viewer signing out must not leave the payload — including, for an admin,
// the team table — in the cache for the next account on this browser.
clearQueryCacheOnUserChange(queryClient)
